import { Deserializable } from '../../../models/protocols/deserializable';
import { Address } from '../../../models/users/dto/address';
import { BeneficiaryTypeEnum } from '../enums/beneficiary-type.enum';
import { BeneficiaryType } from './beneficiary-type';
import { BeneficiaryEntityTypeEnum } from '../enums/beneficiary-entity-type.enum';
import { BeneficiaryEntityType } from './beneficiary-entity-type';
import { BeneficiaryRelationshipToMemberType } from './beneficiary-relationship-to-member-type';
import { BeneficiaryTrustee } from './beneficiary-trustee';

export class Beneficiary implements Deserializable {
  public id: number | null = null;
  public memberBeneficiaryId!: number | null;
  public linkedSpouseId: number | null = null;
  public typeId!: BeneficiaryTypeEnum;
  public type!: BeneficiaryType;
  public entityTypeId!: BeneficiaryEntityTypeEnum;
  public entityType!: BeneficiaryEntityType;
  public relationshipToMemberId!: number;
  public relationshipToMember!: BeneficiaryRelationshipToMemberType;
  public relationshipToMemberOtherDescription: string | null = null;
  public firstName: string | null = null;
  public middleName: string | null = null;
  public lastName: string | null = null;
  public socialInsuranceNumber: string | null = null;
  public email: string | null = null;
  public phoneNumberCountryCode: string | null = null;
  public phoneNumber: string | null = null;
  public birthDate: string | null = null;
  public organizationName: string | null = null;
  public organizationPhoneNumberCountryCode: string | null = null;
  public organizationPhoneNumber: string | null = null;
  public organizationBusinessNumber: string | null = null;
  public address: Address | null = null;
  public sharePercentage!: number;
  public alternateSharePercentage!: number;
  public trustee: BeneficiaryTrustee | null = null;

  public onDeserialize(): void {}
}
